import React, { useState, useEffect } from 'react';

const currencies = [
    { code: 'NGN', symbol: '₦', name: 'Nigerian Naira' },
    { code: 'USD', symbol: '$', name: 'US Dollar' },
    { code: 'EUR', symbol: '€', name: 'Euro' },
    { code: 'GBP', symbol: '£', name: 'British Pound' }
];

// Exchange rates relative to NGN (to be replaced with real API data)
const exchangeRates = {
    NGN: 1,
    USD: 0.0013,  // 1 NGN = 0.0013 USD
    EUR: 0.0012,  // 1 NGN = 0.0012 EUR
    GBP: 0.0010   // 1 NGN = 0.0010 GBP
};

const CurrencyConverter = ({ onCurrencyChange }) => {
    const [selectedCurrency, setSelectedCurrency] = useState('NGN');

    const handleCurrencyChange = (e) => {
        const newCurrency = e.target.value;
        setSelectedCurrency(newCurrency);
        onCurrencyChange({
            code: newCurrency,
            symbol: currencies.find(c => c.code === newCurrency).symbol,
            rate: exchangeRates[newCurrency]
        });
    };

    useEffect(() => {
        // Set initial currency
        onCurrencyChange({
            code: selectedCurrency,
            symbol: currencies.find(c => c.code === selectedCurrency).symbol,
            rate: exchangeRates[selectedCurrency]
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="currency-converter">
            <select 
                value={selectedCurrency}
                onChange={handleCurrencyChange}
                className="currency-select"
            >
                {currencies.map(currency => (
                    <option key={currency.code} value={currency.code}>
                        {currency.symbol} {currency.name}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default CurrencyConverter;
